__turbopack_context__.v({
  "button": "text-image-block-module-scss-module__tt1f4G__button",
  "button1": "text-image-block-module-scss-module__tt1f4G__button1",
  "buttonSimple": "text-image-block-module-scss-module__tt1f4G__buttonSimple",
  "buttonSimple1": "text-image-block-module-scss-module__tt1f4G__buttonSimple1",
  "buttongroup": "text-image-block-module-scss-module__tt1f4G__buttongroup",
  "container": "text-image-block-module-scss-module__tt1f4G__container",
  "iconWrapper": "text-image-block-module-scss-module__tt1f4G__iconWrapper",
  "imageIcon": "text-image-block-module-scss-module__tt1f4G__imageIcon",
  "imageIcon1": "text-image-block-module-scss-module__tt1f4G__imageIcon1",
  "li": "text-image-block-module-scss-module__tt1f4G__li",
  "list": "text-image-block-module-scss-module__tt1f4G__list",
  "raceTeamPlayButton": "text-image-block-module-scss-module__tt1f4G__raceTeamPlayButton",
  "subtitle": "text-image-block-module-scss-module__tt1f4G__subtitle",
  "text": "text-image-block-module-scss-module__tt1f4G__text",
  "text1": "text-image-block-module-scss-module__tt1f4G__text1",
  "textimageblock": "text-image-block-module-scss-module__tt1f4G__textimageblock",
  "title": "text-image-block-module-scss-module__tt1f4G__title",
  "videoWrapper": "text-image-block-module-scss-module__tt1f4G__videoWrapper",
});
